module.exports = __webpack_public_path__ + "static/img/advantages-2.3a011fa3.png";